import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { View, Text, Image} from "react-native";
import { withTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Container, Content, Left, Body, Right, Button,Title,} from "native-base";
import Header from "../../components/ui/WrappedHeader";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import ScreenLoadingIndicator from "../../components/ui/ScreenLoadingIndicator";
import { NavigationService } from "../../navigation";
import UIDs from "../../UIDs";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/me/RewardPlanListRedux";
import Icon from "react-native-vector-icons/Ionicons";

const uid = UIDs.screens.me.rewardPlanList;

class RewardPlanListScreen extends AuthorizedScreen {

    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null },
            [ActionTypes.DELETE_REWARD_PLAN_ASYNC]: { done: this._handleDeleteRewardPlanAsyncDone, error: action => this.displayAsyncActionError(action.error, "deleteRewardPlanFailure") },
        };
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();

        // call load screen view to update analytics
        this.props.loadScreenViewAsync();
    }

    renderScreen() {
        const { rewardPlans } = this.props.localState;
        if (!rewardPlans || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <ScreenLoadingIndicator title={this.props.t("rewardPlan")} />;
        return (
            <Container style={[ styles.backgroundColor]}>
                <Header style={[styles.headerColor]}>
                    <Left style={[ styles.flex1]}>
                        <Button transparent onPress={() => this._onPress()}>
                            <Icon name="ios-arrow-back" style={[ styles.headerIcon]}/>
                        </Button> 
                    </Left>
                    <Body style={[ styles.flex3, styles.alignItemsCenter]}>
                        <Title style={[ styles.headerTitle]}>{this.props.t("rewardPlan")}</Title>
                    </Body>
                    <Right style={[ styles.flex1]}/>
                </Header>
                <Content>
                    {this._renderCurrentRewardPlansArea()}
                    <View style={[ styles.centerAlign, styles.marginTop30]}>
                        <Button transparent onPress={() => this._onPressSetRewardPlan()} style={[ styles.centerAlign, styles.addButton]}>
                            <Text style={[ styles.addText]}>{this.props.t("setNewReward")}</Text>
                        </Button>
                        <Button  transparent onPress={() => this._onPressApprove()} style={[ styles.centerAlign, styles.studyButton, styles.marginTop20]} >
                            <Text style={[ styles.studyText]}>{this.props.t("studyStart")}</Text>
                        </Button>
                    </View>
                    <Text style={[ styles.marginHorizontal16,styles.marginTop30, styles.historyText, styles.marginBottom8]}>{this.props.t("history")}</Text>
                    {this._renderHistoryRewardPlansArea()}
                </Content>
            </Container>
        );
    }

    _renderCurrentRewardPlansArea() {
        const { rewardPlans } = this.props.localState;
        const rewardCycleType = [this.props.t("everyTask"), this.props.t("everyWeek"), this.props.t("everyMonth"), this.props.t("everySeason"), this.props.t("everyYear")];
        let rewardPlanElement = (
            <>
                {!rewardPlans || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <View style={[ styles.headerColor,styles.marginTop2,]}></View>
                    : rewardPlans.map((item, i) => {
                        const { id, rewardCycle, startOn, endOn } = item;
                        return (
                            <View style={[ styles.headerColor,styles.marginTop2,]}>
                                <View style={[ styles.marginHorizontal16, styles.marginVertical16, styles.justifyContentBetween,styles.flexDirection]}>
                                    <Icon name="logo-usd" style={[ styles.usd]}/>
                                    <View style={{ left:0}}>
                                        <Text>{rewardCycleType[rewardCycle]}</Text>
                                        {endOn === "" ? 
                                            (<Text style={[ styles.marginTop2, styles.ListText]}>{this.props.t("effectiveTime")}{startOn} {"                         "}</Text>)
                                            :
                                            (<Text style={[ styles.marginTop2, styles.ListText]}>{this.props.t("effectiveTime")}{startOn} ~ {endOn}</Text>)
                                        }
                                    </View>
                                    <Button transparent style={[ styles.centerAlign, styles.deleteButton]}
                                        onPress={() => this._handleDeleteRewardPlan(id)}>
                                        <Text style={[ styles.deleteText]}>{this.props.t("delete")}</Text>
                                    </Button>
                                </View>
                            </View>
                        );
                    })
                }
            </>
        )
        return rewardPlanElement;
    }

    _renderHistoryRewardPlansArea() {
        const { rewardPlansHistory } = this.props.localState;
        const rewardCycleType = [this.props.t("everyTask"), this.props.t("everyWeek"), this.props.t("everyMonth"), this.props.t("everySeason"), this.props.t("everyYear")];
        let rewardPlanElement = (
            <>
                {!rewardPlansHistory || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <View style={[ styles.headerColor,styles.marginTop2,]}></View>
                    : rewardPlansHistory.map((item, i) => {
                        const { id, rewardCycle, rewardData, amount } = item;
                        return (
                            <View style={[ styles.headerColor,styles.marginTop2,]}>
                                <View style={[ styles.marginHorizontal16, styles.marginVertical16, styles.justifyContentBetween,styles.flexDirection,]}>
                                    <View>
                                        <Text>{rewardCycleType[rewardCycle]}</Text>
                                        <Text style={[ styles.marginTop6, styles.ListText]}>{this.props.t("prize")}{rewardData}</Text>
                                        <Text style={[ styles.marginTop2, styles.ListText]}>{this.props.t("numberTaskCompleted")}{amount === "" ? 0 : amount}</Text>
                                    </View>
                                    <Button transparent onPress={() => this._onPressHistory(i)} style={[ styles.backButton]}>
                                        <Icon name="ios-arrow-forward"  style={[ styles.backIcon]}/>
                                    </Button>
                                </View>
                            </View>
                        );
                    })
                }
            </>
        )
        return rewardPlanElement;
    }

    _handleDeleteRewardPlan = (id) => {
        this.props.deleteRewardPlanAsync(id);
    }

    _onPress = () => {
        NavigationService.navigateToPage(this, UIDs.screens.me.default,);
    };

    _onPressSetRewardPlan = () => {
        // NavigationService.navigateToPage(this, UIDs.screens.me.setRewardPlan,);
        this.props.navigation.navigate(UIDs.screens.me.setRewardPlan,{
            refresh:()=>{
                this.props.loadScreenViewAsync();
            },
        })
    };

    _onPressApprove = () => {
        NavigationService.navigateToPage(this, UIDs.screens.course.list,);
    };

    _onPressHistory = (i) => {
        const { rewardPlansHistory } = this.props.localState;
        const rewardCycleType = [this.props.t("everyTask"), this.props.t("everyWeek"), this.props.t("everyMonth"), this.props.t("everySeason"), this.props.t("everyYear")];
        let id = rewardPlansHistory[i].id;
        let prize = rewardPlansHistory[i].rewardData;
        let rewardCycle = rewardCycleType[rewardPlansHistory[i].rewardCycle];
        NavigationService.navigateToPage(this, UIDs.screens.me.rewardHistory, { id, prize, rewardCycle });
    };

    _handleDeleteRewardPlanAsyncDone = () => {
        this.props.loadScreenViewAsync();
    }

};

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center"
    },

    backgroundColor: {
        backgroundColor:"#f4f4f4"
    },

    headerColor: {
        backgroundColor:"#fff"
    },
  
    headerTitle: {
        color:"#111"
    },

    usd: {
        fontSize:16,
        color:"#eea236",
        top:2
    },
  
    flex1: {
        flex:1
    },
  
    flex3: {
        flex:3
    },
  
    alignItemsCenter: {
        alignItems:"center"
    },

    headerIcon: {
        fontSize:30, 
        color:"#777"
    },

    marginTop30:{
        marginTop:30
    },

    marginTop20:{
        marginTop:20
    },

    marginBottom10:{
        marginBottom:10
    },

    marginTop8:{
        marginTop:8
    },

    marginTop6:{
        marginTop:6
    },

    marginTop2:{
        marginTop:2
    },

    historyText: {
        color:"#999"
    },

    addButton: {
        borderRadius:30,
        width:320, 
        height:50,
        borderWidth:1,
        borderColor:"#5cb85c",
        alignSelf:"center", 
    },

    studyButton: {
        borderRadius:30,
        backgroundColor:"rgb(100,218,73)",
        width:320, 
        height:50,
        alignSelf:"center", 
    },

    studyText: {
        textAlign:"center", 
        fontSize:16,
        color:"#fff"
    },

    addText: {
        textAlign:"center", 
        fontSize:16,
        color:"#5cb85c"
    },

    deleteButton: {
        height:20,
        width:42,
        backgroundColor:"red"
    },

    deleteText: {
        fontSize:10,
        color:"#fff"
    },

    flexDirection: {
        flexDirection:"row"
    },

    justifyContentBetween: {
        justifyContent:"space-between"
    },
    
    marginHorizontal16: {
        marginHorizontal:16
    },

    marginVertical16: {
        marginVertical:16
    },

    ListText: {
        fontSize:12,
        color:"#999"
    },

    backIcon: {
        fontSize:18,
        color:"#ccc",
        alignSelf:"center",
    },

    backButton:{
        width:40, 
        height:60,  
        justifyContent:"flex-end"
    },

    detailText: {
        fontSize:12,
        color:"#999",
        marginTop:6
    }

});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: () => dispatch(Actions.loadScreenViewAsync()),
        deleteRewardPlanAsync: id => dispatch(Actions.deleteRewardPlanAsync(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(RewardPlanListScreen));